import { actionTypes } from './constants';

export const pipelinePagesActionTypes = {
  setSelectedRunIds: actionTypes.PIPELINE_PAGES_SET_SELECTED_RUN_IDS,
  setFetching: actionTypes.PIPELINE_PAGES_SET_FETCHING,
};
